// UsersList/index.js
import { connect } from 'react-redux';

import UsersListforBranch from '../../components/UserListForBranch';
import {
  fetchAllUsersDispatch,
  userEditClickDispatch,
  openEditUserDialogDispatch,
  openDeleteUserDialogDispatch
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    users: state.users.allUsers && state.users.allUsers.items,
    branch: state.branch.branch && state.branch.branch
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    fetchAllUsers: () => {
      dispatch(fetchAllUsersDispatch());
    },
    onUserEditClick: (user) => {
      dispatch(openEditUserDialogDispatch(true));
      dispatch(userEditClickDispatch(user));
    },
    onOpenDeleteUserDialog: (open, user) => {
      dispatch(openDeleteUserDialogDispatch(true));
      dispatch(userEditClickDispatch(user));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersListforBranch);
